import React from "react";
import member1 from "../../assets/about/Generalmanager.jpeg";
import member2 from "../../assets/about/marketing.jpeg";
import member3 from "../../assets/about/marketingexecutie.jpeg";
import member4 from "../../assets/about/Senioraccountant.jpeg";
import member5 from "../../assets/about/asst_general_manager.jpeg";
import member7 from "../../assets/about/marketing-3.jpeg";
import member8 from "../../assets/about/member7.jpeg";
import member6 from "../../assets/about/Reception.jpeg";
import member10 from "../../assets/about/Telecaller-1.jpeg";
import member9 from "../../assets/about/TeleCaller-2.jpeg";
import member11 from "../../assets/about/accountant.jpeg";
import member12 from "../../assets/about/marketing-2.jpeg";
import member13 from "../../assets/about/Telecaller-3.jpeg";
import member14 from "../../assets/about/Telecaller-4.jpeg";
import member15 from "../../assets/about/Telecaller-5.jpeg";
import member16 from "../../assets/about/Telecaller-6.jpeg";
import member17 from "../../assets/about/Telecaller-7.jpeg";
import member18 from "../../assets/about/marketing-head.jpeg";
import member19 from "../../assets/about/marketing-1.jpeg";

const members = [
  {
    id: 1,
    name: "Amit Kumar Dash",
    role: "General Manager",
    image: member4,
  },
  {
    id: 2,
    name: "Dhanajay Barik",
    role: "Asst. general manager",
    image: member5,
  },
  {
    id: 2,
    name: "Monalisha Samal",
    role: "Hr/Senior Accountant",
    image: member11,
  },
  {
    id: 3,
    name: "Bishwajit Pradhan",
    role: "Marketing Head",
    image: member18,
  },
  {
    id: 4,
    name: "Priyabrata Malick",
    role: "Marketing",
    image: member19,
  },
  {
    id: 11,
    name: "Rudra Madhab Nahak",
    role: "Marketing",
    image: member12,
  },
  {
    id: 12,
    name: "Dhanajay Parida",
    role: "Marketing",
    image: member7,
  },

  // {
  //   id: 5,
  //   name: "Lelin kumar Nayak",
  //   role: "Marketing Executives",
  //   image: member5,
  // },
  {
    id: 6,
    name: "Sasmita Sahoo",
    role: "Reception/ Telecaller",
    image: member6,
  },
  // {
  //   id: 6,
  //   name: "Bharati Sahoo",
  //   role: "Telecaller",
  //   image: member8,
  // },
  // {
  //   id: 7,
  //   name: "Nihar Ranjan Dash",
  //   role: "Office boy/Driver",
  //   image: member7,
  // },
  {
    id: 8,
    name: "Suchitra Swain",
    role: "Telecaller",
    image: member9,
  },
  {
    id: 9,
    name: "Madhusmita Basita",
    role: "Telecaller",
    image: member10,
  },

  {
    id: 12,
    name: "Lily Adhek",
    role: "Telecaller",
    image: member13,
  },
  {
    id: 13,
    name: "Dipti Mangaraj",
    role: "Telecaller",
    image: member14,
  },
  {
    id: 14,
    name: "Itishree Jena",
    role: "Telecaller",
    image: member15,
  },
  {
    id: 15,
    name: "Liza Dash",
    role: "Telecaller",
    image: member16,
  },
  {
    id: 16,
    name: "Tapaswini Mishra",
    role: "Telecaller",
    image: member17,
  },
];

const TeamMember = () => {
  return (
    <div className="px-10 py-8 w-full ">
      <div className="flex flex-col items-center justify-center">
        <h1 className="font-semibold text-3xl md:text-4xl tracking-wide text-center">
          Team Members
        </h1>
        <p className="text-gray-400 text-sm mt-3 text-center mx-auto max-w-3xl tracking-wide">
          "Meet our dedicated team members who bring expertise, passion, and
          innovation to every project. Together, we work collaboratively to
          achieve excellence, ensuring success and satisfaction for our clients
          and partners."
        </p>
      </div>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-8">
        {members.map(({ id, name, role, image }) => (
          <div
            key={id}
            className="bg-[#f8f7fc] rounded-lg overflow-hidden shadow w-full sm:w-[48%] md:w-[30%] lg:w-[22%] flex-shrink-0"
          >
            <img
              src={image}
              alt={name}
              className="rounded-lg w-full h-[20rem] sm:h-[22rem] md:h-[25rem] lg:h-[28rem] object-cover"
            />
            <div className="p-4 text-center">
              <h3 className="font-semibold text-lg">{name}</h3>
              <p className="text-xl text-gray-500 font-serif">{role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamMember;
